(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lev-art-product-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lev-art-size-guide')) {
    customElements.define('lev-art-size-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('[data-la-guide-open]');
        if (!this.dialog || !this.trigger || typeof this.dialog.showModal !== 'function') return;
        this.controller = new AbortController();
        const listener = { signal: this.controller.signal };
        this.tabs = [...this.querySelectorAll('[data-la-guide-tab]')];
        this.setTab(this.dataset.defaultOrientation || 'portrait');
        this.trigger.addEventListener('click', event => { event.preventDefault(); this.openGuide(); }, listener);
        this.querySelector('[data-la-guide-close]').addEventListener('click', () => this.dialog.close(), listener);
        this.tabs.forEach(tab => {
          tab.addEventListener('click', () => this.setTab(tab.dataset.laGuideTab, true), listener);
          tab.addEventListener('keydown', event => {
            const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
            if (!keys.includes(event.key)) return;
            event.preventDefault();
            let index = this.tabs.indexOf(tab);
            if (event.key === 'Home') index = 0;
            else if (event.key === 'End') index = this.tabs.length - 1;
            else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
            this.setTab(this.tabs[index].dataset.laGuideTab, true);
          }, listener);
        });
        this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.dialog.close(); }, listener);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, listener);
        this.dialog.addEventListener('close', () => this.releaseGuide(), listener);
      }
      setTab(orientation, focus = false) {
        const active = this.tabs.find(tab => tab.dataset.laGuideTab === orientation) || this.tabs[0];
        this.tabs.forEach(tab => {
          const selected = tab === active;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        this.querySelectorAll('[data-la-guide-panel]').forEach(panel => { panel.hidden = panel.dataset.laGuidePanel !== active.dataset.laGuideTab; });
        if (focus) active.focus();
      }
      openGuide() {
        if (this.dialog.open) return;
        this.dialog.showModal();
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.scrollLocked = true;
        this.querySelector('[data-la-guide-close]').focus();
      }
      releaseGuide() {
        if (!this.scrollLocked) return;
        document.documentElement.style.overflow = this.previousOverflow;
        this.scrollLocked = false;
        if (this.trigger.isConnected) this.trigger.focus();
      }
      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.releaseGuide();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
  if (!customElements.get('lev-art-product')) {
    customElements.define('lev-art-product', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        const source = this.querySelector('[data-la-variants]');
        if (!source) return;
        try { this.variants = JSON.parse(source.textContent); } catch { return; }
        this.select = this.querySelector('[data-la-variant]');
        this.quantity = this.querySelector('[data-la-quantity]');
        this.submit = this.querySelector('[data-la-submit]');
        this.price = this.querySelector('[data-la-price]');
        this.availability = this.querySelector('[data-la-availability]');
        if (!this.select || !this.quantity || !this.submit || !this.price) return;
        this.controller = new AbortController();
        const listener = { signal: this.controller.signal };
        this.current = this.variants.find(v => String(v.id) === this.select.value) || this.variants[0];
        this.options = this.current ? [...this.current.options] : [];
        const customPicker = this.querySelector('[data-la-custom-picker]');
        if (customPicker) { customPicker.hidden = false; this.querySelector('[data-la-native-picker]').hidden = true; }
        this.querySelectorAll('[data-la-quantity-step]').forEach(button => { button.hidden = false; });
        const thumbs = this.querySelector('[data-la-thumbs]');
        if (thumbs) thumbs.hidden = false;
        const galleryNavigation = this.querySelector('[data-la-gallery-navigation]');
        if (galleryNavigation) galleryNavigation.hidden = false;
        this.addEventListener('click', event => {
          const imageButton = event.target.closest('[data-la-show-image]');
          if (imageButton && this.contains(imageButton)) this.showImage(imageButton.dataset.laShowImage);
          const galleryStep = event.target.closest('[data-la-gallery-step]');
          if (galleryStep && this.contains(galleryStep)) this.stepImage(Number(galleryStep.dataset.laGalleryStep));
          const choice = event.target.closest('[data-la-choice]');
          if (choice && this.contains(choice)) {
            this.options[Number(choice.dataset.optionIndex)] = choice.dataset.optionValue;
            this.current = this.variants.find(v => v.options.every((value, index) => value === this.options[index]));
            this.update(true);
          }
          const stepButton = event.target.closest('[data-la-quantity-step]');
          if (stepButton && this.contains(stepButton)) {
            this.quantity.value = this.normalizedQuantity() + Number(stepButton.dataset.laQuantityStep) * this.rule('step');
            this.normalizeQuantity();
          }
        }, listener);
        const stage = this.querySelector('.la-image-stage');
        if (stage) {
          stage.addEventListener('touchstart', event => {
            this.lastTouch = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
          }, { ...listener, passive: true });
          stage.addEventListener('touchend', event => {
            if (!this.lastTouch || event.touches.length || event.changedTouches.length !== 1) return;
            const x = event.changedTouches[0].clientX - this.lastTouch.x;
            const y = event.changedTouches[0].clientY - this.lastTouch.y;
            this.lastTouch = null;
            if (Math.abs(x) > 45 && Math.abs(x) > Math.abs(y) * 1.4) this.stepImage(x < 0 ? 1 : -1);
          }, { ...listener, passive: true });
          stage.addEventListener('touchcancel', () => { this.lastTouch = null; }, listener);
        }
        this.select.addEventListener('change', () => {
          this.current = this.variants.find(v => String(v.id) === this.select.value);
          this.options = this.current ? [...this.current.options] : [];
          this.update(true);
        }, listener);
        this.quantity.addEventListener('change', () => this.normalizeQuantity(), listener);
        this.querySelector('form').addEventListener('submit', event => {
          if (!this.current || !this.current.available) { event.preventDefault(); return; }
          this.normalizeQuantity();
        }, listener);
        this.update(false);
        const activeImage = this.querySelector('[data-la-image]:not([hidden])');
        if (activeImage) this.showImage(activeImage.dataset.laImage);
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
      rule(key) { return Number(this.current?.[key]) || 1; }
      normalizedQuantity() {
        const min = this.rule('min'), step = this.rule('step');
        const raw = Number(this.quantity.value);
        let value = Number.isFinite(raw) ? Math.max(min, min + Math.floor((raw - min) / step) * step) : min;
        const max = Number(this.current?.max);
        if (max > 0) value = Math.min(value, min + Math.floor((max - min) / step) * step);
        return value;
      }
      normalizeQuantity() {
        this.quantity.value = this.normalizedQuantity();
        const value = Number(this.quantity.value), max = Number(this.current?.max);
        this.querySelector('[data-la-quantity-step="-1"]').disabled = value <= this.rule('min');
        this.querySelector('[data-la-quantity-step="1"]').disabled = max > 0 && value + this.rule('step') > max;
      }
      showImage(id) {
        const panels = [...this.querySelectorAll('[data-la-image]')];
        if (!panels.some(panel => panel.dataset.laImage === String(id))) return;
        panels.forEach(panel => { panel.hidden = panel.dataset.laImage !== String(id); });
        this.querySelectorAll('[data-la-show-image]').forEach(button => {
          const active = button.dataset.laShowImage === String(id);
          button.setAttribute('aria-pressed', String(active));
          const strip = button.parentElement;
          if (active && typeof strip.scrollTo === 'function') {
            const left = button.offsetLeft, right = left + button.offsetWidth;
            if (left < strip.scrollLeft) strip.scrollTo({ left });
            else if (right > strip.scrollLeft + strip.clientWidth) strip.scrollTo({ left: right - strip.clientWidth });
          }
        });
        const counter = this.querySelector('[data-la-counter]');
        if (counter) counter.textContent = `${panels.findIndex(panel => panel.dataset.laImage === String(id)) + 1} / ${panels.length}`;
      }
      stepImage(step) {
        const panels = [...this.querySelectorAll('[data-la-image]')];
        if (!panels.length) return;
        const index = Math.max(0, panels.findIndex(panel => !panel.hidden));
        this.showImage(panels[(index + step + panels.length) % panels.length].dataset.laImage);
      }
      update(updateUrl) {
        const variant = this.current;
        this.select.disabled = !variant;
        this.select.value = variant ? String(variant.id) : '';
        this.submit.disabled = !variant || !variant.available;
        this.submit.textContent = !variant ? this.dataset.unavailableLabel : variant.available ? this.dataset.addLabel : this.dataset.soldLabel;
        this.price.textContent = variant ? variant.priceText : this.dataset.unavailableLabel;
        this.availability.hidden = Boolean(variant?.available);
        this.availability.textContent = variant?.available ? '' : this.submit.textContent;
        this.querySelectorAll('[data-la-choice]').forEach(button => {
          const index = Number(button.dataset.optionIndex), value = button.dataset.optionValue;
          const candidate = this.variants.find(v => v.options[index] === value && v.options.every((part, position) => position === index || part === this.options[position]));
          button.setAttribute('aria-pressed', String(this.options[index] === value));
          button.classList.toggle('is-sold-out', !candidate || !candidate.available);
          button.querySelector('[data-la-choice-price]').textContent = candidate ? candidate.priceText : '';
        });
        this.quantity.min = String(this.rule('min'));
        this.quantity.step = String(this.rule('step'));
        if (variant?.max) this.quantity.max = String(variant.max); else this.quantity.removeAttribute('max');
        this.normalizeQuantity();
        if (updateUrl && variant) {
          if (variant.imageId) this.showImage(variant.imageId);
          try { const url = new URL(window.location.href); url.searchParams.set('variant', String(variant.id)); window.history.replaceState(window.history.state, '', url); } catch {}
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
